import { render, staticRenderFns } from "./AddDeliver.vue?vue&type=template&id=31234262&scoped=true"
import script from "./AddDeliver.vue?vue&type=script&lang=js"
export * from "./AddDeliver.vue?vue&type=script&lang=js"
import style0 from "./AddDeliver.vue?vue&type=style&index=0&id=31234262&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31234262",
  null
  
)

export default component.exports